import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10070702&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=10070702&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=10070702&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10070702",
  null
  
)

export default component.exports